import { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { isEditing, isAdding } from '../reducers/checkoutShippingReducer';
import { isOnPaymentPane, isOnShippingPane } from '../reducers/checkoutPaneReducer';
import { setShowAddressFormErrors } from '../actions/checkoutShippingActions';
import { connect } from 'react-redux';
import styles from './styles/checkoutConfirmModal.scss';

// components
import CheckoutCancelAction from '../components/shared/actions/CheckoutCancelAction';
import CheckoutCTAButton from '../components/shared/CheckoutCTAButton';

import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { Button } from 'dibs-elements/exports/Button';

class CheckoutConfirmModal extends Component {
    constructor(props) {
        super(props);
        this.onConfirm = this.onConfirm.bind(this);
        this.state = { isSaving: false };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setState({ isSaving: false });
        }
    }
    getTitle() {
        const { isOnShipping, isOnPayment, isAddingShipping, isEditingShipping } = this.props;

        if (isAddingShipping || isEditingShipping) {
            return (
                <FormattedMessage
                    id="checkout.CheckoutConfirmModal.changingTitle"
                    defaultMessage="Save Updates?"
                />
            );
        } else if (isOnShipping) {
            return (
                <FormattedMessage
                    id="checkout.CheckoutConfirmModal.deletingShippingTitle"
                    defaultMessage="Delete Shipping Address?"
                />
            );
        } else if (isOnPayment) {
            return (
                <FormattedMessage
                    id="checkout.CheckoutConfirmModal.deletingPaymentTitle"
                    defaultMessage="Delete Payment Method?"
                />
            );
        }
        return '';
    }
    getContent() {
        const { isOnShipping, isOnPayment, isAddingShipping, isEditingShipping } = this.props;

        if (isOnShipping) {
            if (isAddingShipping || isEditingShipping) {
                return (
                    <FormattedMessage
                        id="checkout.CheckoutConfirmModal.changingContent"
                        defaultMessage="Do you want to save the changes made to your existing address?"
                    />
                );
            }
            return (
                <FormattedMessage
                    id="checkout.CheckoutConfirmModal.deletingShippingContent"
                    defaultMessage="Permanently delete this shipping address?"
                />
            );
        } else if (isOnPayment) {
            return (
                <FormattedMessage
                    id="checkout.CheckoutConfirmModal.deletingPaymentContent"
                    defaultMessage="Permanently delete this payment method?"
                />
            );
        }
        return '';
    }
    getConfirmLabel() {
        const { isAddingShipping, isEditingShipping } = this.props;

        if (isAddingShipping || isEditingShipping) {
            return (
                <span>
                    <FormattedMessage
                        id="checkout.CheckoutConfirmModal.changingConfirmLabel"
                        defaultMessage="Save"
                    />
                </span>
            );
        }
        return (
            <span>
                <FormattedMessage
                    id="checkout.CheckoutConfirmModal.deletingConfirmLabel"
                    defaultMessage="Delete"
                />
            </span>
        );
    }
    onConfirm(event) {
        this.props.onSetShowAddressFormErrors(this.props.isAddingShipping);
        this.props.onConfirm(event);
        this.setState({ isSaving: true });
    }
    render() {
        const { isSaving } = this.state;
        const { isOpen, onDischarge, onClose } = this.props;
        return (
            <ModalContainer isOpen={isOpen} modalPosition="center" onClose={onClose}>
                <BarHeader title={this.getTitle()} />
                <ModalBody>
                    <div className={styles.body}>{this.getContent()}</div>
                    <div className={styles.buttons}>
                        <Button
                            disabled={isSaving}
                            type="secondary"
                            size="medium"
                            className={styles.cancel}
                            onClick={onDischarge}
                            dataTn="modal-button-cancel"
                        >
                            <CheckoutCancelAction />
                        </Button>
                        <CheckoutCTAButton
                            size="medium"
                            customClass={styles.submit}
                            disabled={isSaving}
                            onClick={this.onConfirm}
                            dataTn="modal-button-submit"
                            isSaving={isSaving}
                            isBlocked={isSaving}
                            label={this.getConfirmLabel()}
                        />
                    </div>
                </ModalBody>
            </ModalContainer>
        );
    }
}

CheckoutConfirmModal.propTypes = {
    isOpen: PropTypes.bool,
    isOnShipping: PropTypes.bool.isRequired,
    isOnPayment: PropTypes.bool.isRequired,
    isAddingShipping: PropTypes.bool.isRequired,
    isEditingShipping: PropTypes.bool.isRequired,
    onDischarge: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onSetShowAddressFormErrors: PropTypes.func,
};

CheckoutConfirmModal.defaultProps = {
    isOpen: false,
};

const ConnectedCheckoutConfirmModal = connect(
    ({ shipping, pane }) => ({
        isOnShipping: isOnShippingPane(pane),
        isOnPayment: isOnPaymentPane(pane),
        isAddingShipping: isAdding(shipping),
        isEditingShipping: isEditing(shipping),
    }),
    dispatch => ({
        onSetShowAddressFormErrors: payload => dispatch(setShowAddressFormErrors(payload)),
    })
)(CheckoutConfirmModal);

export default ConnectedCheckoutConfirmModal;
